module.exports = __webpack_public_path__ + "media/36.cc477bcd.mp3";